import Phaser from "phaser";
import * as Controller from "../components/Controller/Controller";
import UIMenus from "../components/UIMenus";
import { SCALE } from "../utils/constants";
import CRTFilter from "../utils/CRTShaderFX";
import dbManager from "../utils/dbManager";

let titlesMusic;
export default class ConfirmNewGameScene extends Phaser.Scene {
  constructor() {
    super("ConfirmNewGameScene");
  }

  preload() {}

  navigateToScene(sceneId, props = {}) {
    this.cameras.main.fade(500, 0, 0, 0);
    this.tweens.add({
      targets: titlesMusic,
      volume: 0,
      ease: "Linear",
      duration: 500,
      onComplete: () => {
        titlesMusic.pause();
        this.scene.start(sceneId, props);
      },
    });
  }

  create() {
    this.cameras.main.setPostPipeline(CRTFilter);
    this.cameras.main.setBackgroundColor("#486859");

    let image = this.add.image(
      this.cameras.main.width / 2,
      this.cameras.main.height / 3,
      "Bossfight"
    );
    let scaleX = this.cameras.main.width / image.width;
    let scaleY = this.cameras.main.height / image.height;
    let scale = Math.max(scaleX, scaleY);
    image.setScale(scale * 1.5).setScrollFactor(0);
    image.name = "background_art";

    // //  Enable lights and set a dark ambient color
    // this.lights.enable().setAmbientColor(0x333333);
    // image.setPipeline("Light2D");
    // //  Our spotlight. 100px radius and white in color.
    // var light = this.lights
    //   .addLight(180, 80, 200)
    //   .setColor(0xffffff)
    //   .setIntensity(2);
    // //  Track the pointer
    // this.input.on("pointermove", function (pointer) {
    //   light.x = pointer.x;
    //   light.y = pointer.y;
    // });

    // var flash = this.plugins.get('rexFlash').add(part);
    // flash.flash()

    // var particles = this.add.particles('spark').setScale(SCALE);

    // var emitter = particles.createEmitter();

    // emitter.setPosition(10*SCALE, 10*SCALE);
    // emitter.setSpeed(20);
    // // emitter.setBlendMode(Phaser.BlendModes.ADD);

    // off-line version
    // this.cameras.main.fadeIn(500, 0, 0, 0);
    // this.events.emit("scene_ready", this.sys.config);
    // const mainMenu = new UIMenus(this);
    // mainMenu.showMainMenu();
    // titlesMusic = this.sound.add("credits", { loop: true });
    // return false

    titlesMusic = this.sound.add("credits", { loop: true });

    window.WebFont.load({
      custom: {
        families: ["GameGirl"],
      },
      active: () => {
        this.cameras.main.fadeIn(500, 0, 0, 0);
        this.events.emit("scene_ready", this.sys.config);

        titlesMusic = this.sound.add("credits", { loop: true });

        // titlesMusic.play();

        // this.events.once(Phaser.Scenes.Events.WAKE, () => console.log(Phaser.Scenes.Events.WAKE))
        // this.events.once(Phaser.Scenes.Events.UPDATE, () => console.log(Phaser.Scenes.Events.UPDATE))
        // this.events.once(Phaser.Scenes.Events.TRANSITION_WAKE, () => console.log(Phaser.Scenes.Events.TRANSITION_WAKE))
        // this.events.once(Phaser.Scenes.Events.TRANSITION_START, () => console.log(Phaser.Scenes.Events.TRANSITION_START))
        // this.events.once(Phaser.Scenes.Events.TRANSITION_OUT, () => console.log(Phaser.Scenes.Events.TRANSITION_OUT))
        // this.events.once(Phaser.Scenes.Events.TRANSITION_INIT, () => console.log(Phaser.Scenes.Events.TRANSITION_INIT))
        // this.events.once(Phaser.Scenes.Events.TRANSITION_COMPLETE, () => console.log(Phaser.Scenes.Events.TRANSITION_COMPLETE))
        // this.events.once(Phaser.Scenes.Events.START, () => console.log(Phaser.Scenes.Events.START))
        // this.events.once(Phaser.Scenes.Events.SLEEP, () => console.log(Phaser.Scenes.Events.SLEEP))
        // this.events.once(Phaser.Scenes.Events.SHUTDOWN, () => console.log(Phaser.Scenes.Events.SHUTDOWN))
        // this.events.once(Phaser.Scenes.Events.RESUME, () => console.log(Phaser.Scenes.Events.RESUME))
        // this.events.once(Phaser.Scenes.Events.RENDER, () => console.log(Phaser.Scenes.Events.RENDER))
        // this.events.once(Phaser.Scenes.Events.READY, () => console.log(Phaser.Scenes.Events.READY))
        // this.events.once(Phaser.Scenes.Events.PRE_RENDER, () => console.log(Phaser.Scenes.Events.PRE_RENDER))
        // this.events.once(Phaser.Scenes.Events.PAUSE, () => console.log(Phaser.Scenes.Events.PAUSE))
        // this.events.once(Phaser.Scenes.Events.CREATE, () => console.log(Phaser.Scenes.Events.CREATE))
        // this.events.once(Phaser.Scenes.Events.BOOT, () => console.log(Phaser.Scenes.Events.BOOT))

        this.input.keyboard.off("keydown");
        this.input.keyboard.on("keydown", (event) => {
          if (Controller.isCancel( event.key)) {
            this.navigateToScene("SplashScreenScene");
          }
        });

        const mainMenu = new UIMenus(this);
        mainMenu.showConfirmNewGameMenu();
        // mainMenu.showMainMenu();
      },
    });
  }
}
